"use client"

import LatestNewsContent from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/LatestNews/components/LatestNewsContent"
import { mapPostToArticle } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/LatestNews/utils/utils"
import { useNotificationCategoryList } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/NotificationList/hooks/useNotificationCategoryList.ts" // Hook mới
import { HeroBannerWithBreadcrumbContent } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/HeroBannerWithBreadcrumb/components/HeroBannerWithBreadcrumbContent"
import CategoryBanner from "@/components/category-banner"
import { t } from "@/languages/i18n"
import { getLocaleHomeHref, getLocalizedHref } from "@/lib/locale-utils"
import useIsMobile from "@/lib/config/lib/use-is-mobile"
import { SiteId } from "@/sites/config"
import { Meta, PostData } from "@/types/types"
import { useMemo } from "react"

interface NotificationCategoryPageProps {
  initialPosts?: PostData[]
  initialMeta?: Meta
  categoryName?: string
  categoryId: number
  categorySlug?: string
  locale: string
  currentPage?: number
  siteId?: SiteId
  heroBannerUrl?: string | null
}

const NotificationCategoryPage = ({
  initialPosts = [],
  initialMeta,
  categoryName,
  categoryId,
  categorySlug = "",
  locale,
  currentPage = 1,
  siteId,
  heroBannerUrl,
}: NotificationCategoryPageProps) => {
  const {
    posts,
    loading,
    currentPage: activePage,
    totalPages,
    setCurrentPage,
  } = useNotificationCategoryList({
    categoryId,
    initialPosts,
    initialMeta,
    initialPage: currentPage,
    locale,
    pageSize: 10,
  })

  const articles = useMemo(() => posts.map(mapPostToArticle), [posts])
  const isMobile = useIsMobile()
  // Cụm tamdaone: hero banner breadcrumb (giống post detail). tamdamedia: promo banner.
  const isTamdaOne = siteId !== undefined && siteId !== "tamdamedia.eu"

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <>
      {isTamdaOne ? (
        heroBannerUrl && (
          <HeroBannerWithBreadcrumbContent
            id="notification-category-hero-banner"
            image={heroBannerUrl}
            title={categoryName || "Thông báo"}
            breadcrumb={[
              { title: t("TRANG CHỦ"), link: getLocaleHomeHref(locale) },
              { title: (categoryName || "Thông báo").toUpperCase(), link: getLocalizedHref(locale, `/category/${categorySlug}`) },
            ]}
            isTamdaOne
          />
        )
      ) : (
        <div className="w-full max-w-[1304px] mx-auto px-4 mb-6">
          <CategoryBanner isMobile={isMobile} autoFetch={true} page="CATEGORY" position="TOP_CONTENT" />
        </div>
      )}
      <div className="w-full max-w-[1304px] mx-auto px-4 sm:pt-[80px] pt-[62px] pb-[94px]">
        <LatestNewsContent
          articles={articles}
          currentPage={activePage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          loading={loading}
          title={categoryName || "Thông báo"}
        />
      </div>
    </>
  )
}

export default NotificationCategoryPage
